const uploadcareScript = `
  UPLOADCARE_PUBLIC_KEY = '${process.env.UPLOADCARE_PUBLIC_KEY}';
`;

export default uploadcareScript;
